import { UserJob, UserLevel } from "@redotech/account-common/job-level";
import { signupAttributionSchema } from "@redotech/account-common/signup-attribution";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const completeSignup = {
  name: "completeSignup" as const,
  input: z.object({
    email: z.email(),
    otpId: z.string(),
    passcode: z.string(),
    businessName: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    phone: z.string().optional(),
    storeUrl: z.string(),
    jobProfile: z
      .object({
        job: z.array(createEnum(UserJob, { enumName: "UserJob" })).optional(),
        level: createEnum(UserLevel, { enumName: "UserLevel" }).optional(),
      })
      .optional(),
    address: z
      .object({
        street1: z.string().optional(),
        street2: z.string().optional(),
        city: z.string().optional(),
        state: z.string().optional(),
        zip: z.string().optional(),
        country: z.string().optional(),
        countryName: z.string().optional(),
      })
      .optional(),
    referralToken: z.string().optional(),
    attribution: signupAttributionSchema.optional(),
  }),
  output: z.object({
    success: z.boolean(),
    authToken: z.string().optional(),
    teamId: z.string().optional(),
    error: z.string().optional(),
  }),
};
